import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private Customer Types */
import {
  _CustomerBranchOfficeBankAccounts,
  Settings
} from '../namespace-helper'

import _ from 'lodash'

const selectedBranchOfficeBankAccountTemplate = {
  id: 0,
  name: '',
  iban: '',
  bic: '',
  customers_branch_offices_id: null
}

export default {
  namespaced: true,
  state: {
    branchOfficeBankAccounts: null,
    selectedBranchBankAccount: _.cloneDeep(selectedBranchOfficeBankAccountTemplate)
  },
  mutations: {
    [_CustomerBranchOfficeBankAccounts.mutations.addNewBranchOfficeBankAccount] (state, payload) {
      if (state.branchOfficeBankAccounts === null) {
        state.branchOfficeBankAccounts = []
      }
      state.branchOfficeBankAccounts.push(payload)
    },
    [_CustomerBranchOfficeBankAccounts.mutations.setSelectedBranchOfficeBankAccount] (state, payload) {
      if (payload !== null) {
        state.selectedBranchBankAccount = payload
      } else {
        state.selectedBranchBankAccount = _.cloneDeep(selectedBranchOfficeBankAccountTemplate)
      }
    },
    [_CustomerBranchOfficeBankAccounts.mutations.removeBranchOfficeBankAccount] (state, payload) {
      state.branchOfficeBankAccounts.splice(payload, 1)
    },
    [_CustomerBranchOfficeBankAccounts.mutations.setBranchOfficesBankAccounts] (state, payload) {
      state.branchOfficeBankAccounts = payload
    }
  },
  actions: {
    [_CustomerBranchOfficeBankAccounts.actions.saveBranchOfficeBankAccounts] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      payload.forEach(function (v, i, o) {
        const data = JSON.stringify(v)

        if (v.id === 0) {
          var url = API_URL + '/api/v1/customerBranchOfficeBankAccounts'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/customerBranchOfficeBankAccounts/' + v.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_CustomerBranchOfficeBankAccounts.actions.loadBranchOfficeBankAccounts] (context, payload) {
      var url = API_URL + '/api/v1/customerBranchOfficeBankAccounts/branchOffice/' + payload

      console.log('loadBranchOfficeBankAccounts: ' + payload)

      store.commit(Settings.mutations.setLoading, true)

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_CustomerBranchOfficeBankAccounts.mutations.setBranchOfficesBankAccounts, r.data.data)
        console.log('loadBranchOfficeBankAccounts: ' + JSON.stringify(r.data))
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_CustomerBranchOfficeBankAccounts.actions.removeBranchOfficeBankAccount] (context, payload) {
      const tempBranchOfficeBankBankAccount = context.getters.getBranchOfficeBankAccounts
      const id = tempBranchOfficeBankBankAccount[payload].id

      if (id === 0) {
        context.commit(_CustomerBranchOfficeBankAccounts.mutations.removeBranchOfficeBankAccount, payload)
        return
      }

      var url = API_URL + '/api/v1/supplierBankAccounts/' + id

      console.log('removeBranchOfficeBankAccount: ' + id)

      store.commit(Settings.mutations.setLoading, true)

      axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        ErrorHandler.clear(store)
        context.commit(_CustomerBranchOfficeBankAccounts.mutations.removeBranchOfficeBankAccount, payload)
        store.commit(Settings.mutations.setLoading, false)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
        store.commit(Settings.mutations.setLoading, false)
      }).catch(e => console.error('#### ' + e))
    },
    [_CustomerBranchOfficeBankAccounts.actions.addNewBranchOfficeBankAccount] ({ commit }, payload) {
      commit(_CustomerBranchOfficeBankAccounts.mutations.addNewBranchOfficeBankAccount, payload)
    },
    [_CustomerBranchOfficeBankAccounts.actions.setSelectedBranchOfficeBankAccount] ({ commit }, payload) {
      commit(_CustomerBranchOfficeBankAccounts.mutations.setSelectedBranchOfficeBankAccount, payload)
    },
    [_CustomerBranchOfficeBankAccounts.actions.resetState] ({ commit }, payload) {
      commit(_CustomerBranchOfficeBankAccounts.mutations.setBranchOfficesBankAccounts, [])
      commit(_CustomerBranchOfficeBankAccounts.mutations.setSelectedBranchOfficeBankAccount, null)
    }
  },
  getters: {
    [_CustomerBranchOfficeBankAccounts.getters.getBranchOfficeBankAccounts] (state) {
      return state.branchOfficeBankAccounts
    },
    [_CustomerBranchOfficeBankAccounts.getters.getSelectedBranchOfficeBankAccount] (state) {
      return state.selectedBranchBankAccount
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Customer/customerBranchOfficesBankAccounts.js